import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { startAnalytics, trackPageview } from "@/lib/analytics";

/**
 * First-party, cookieless analytics. Boots the collector once and records a
 * page view on every SPA route change. Independent of the marketing consent
 * stack — stores only anonymous, aggregate behaviour in our own database.
 */
const AnalyticsProvider = () => {
  const location = useLocation();

  useEffect(() => {
    startAnalytics();
  }, []);

  useEffect(() => {
    // Admin/dashboard traffic is excluded inside trackPageview, which also
    // closes out the previous public page's engagement on the transition.
    trackPageview(location.pathname);
  }, [location.pathname]);

  return null;
};

export default AnalyticsProvider;
